export function setMatchStartTime(isOverdue: boolean) {
    const matchDate = new Date(Date.now())
    const dayDiff = isOverdue ? -7 : 7
    const localStartTime = new Date(
        matchDate.setDate(matchDate.getDate() + dayDiff),
    ).toISOString()

    return localStartTime
}
